import { useState } from "react";
import { InputWrapper, SelectInput } from "../../../pages/onboarding/AboutYouConnectWith.page";
import { Row } from "../../../styles/Utils";

interface AgeRangeInputProps {
  value1: number | string;
  value2: number | string;
  onChange1: (value: number) => void;
  onChange2: (value: number) => void;
}

export function AgeRangeInput({ value1, value2, onChange1, onChange2 }: AgeRangeInputProps) {
  const [selectedAge, setSelectedAge] = useState<number | string>(value1 || "");

  const handleAgeFromChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newAge = Number(event.target.value);
    setSelectedAge(newAge);
    onChange1(newAge);
  };

  const handleAgeToChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange2(Number(event.target.value));
  };

  const generateAgeOptions = () => Array.from({ length: 83 }, (_, i) => i + 18);

  const generateFilteredOptions = () => {
    const minAge = typeof selectedAge === "number" ? selectedAge : 18;
    return Array.from({ length: 101 - minAge }, (_, i) => i + minAge);
  };

  return (
    <InputWrapper>
      <Row $justifyContent="space-between">
        <span>Age:</span>
        <Row>
          <span>From</span>
          <SelectInput value={value1} onChange={handleAgeFromChange} $marginInline="1rem">
            {generateAgeOptions().map((age) => (
              <option key={age} value={age}>
                {age}
              </option>
            ))}
          </SelectInput>
          <span> to </span>
          <SelectInput value={value2} onChange={handleAgeToChange} $marginInline="1rem 0">
            {generateFilteredOptions().map((age) => (
              <option key={age} value={age}>
                {age}
              </option>
            ))}
          </SelectInput>
        </Row>
      </Row>
    </InputWrapper>
  );
}
